import React from 'react';
import { TrendingUp, DollarSign, Users } from 'lucide-react';

const CrisisStats = () => {
  return (
    <section className="relative py-16 bg-gradient-to-b from-[#0a0a0a] to-[#1a1a1a]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* 70% Recidivism */}
          <div className="bg-gradient-to-br from-[#1a1a1a] to-[#0f0f0f] border-2 border-[#E63946]/30 rounded-2xl p-8 text-center transform hover:scale-105 transition-all duration-300 hover:border-[#E63946]">
            <div className="w-16 h-16 bg-[#E63946]/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <TrendingUp className="w-8 h-8 text-[#E63946]" />
            </div>
            <div className="text-7xl font-bold text-[#E63946] mb-3" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
              70%
            </div>
            <div className="text-xl text-white font-bold mb-2" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
              RECIDIVISM RATE
            </div>
            <p className="text-gray-400 text-sm">
              Without rehabilitation programs, 7 out of 10 return to prison
            </p>
          </div>

          {/* $0 Funding */}
          <div className="bg-gradient-to-br from-[#1a1a1a] to-[#0f0f0f] border-2 border-[#E63946]/30 rounded-2xl p-8 text-center transform hover:scale-105 transition-all duration-300 hover:border-[#E63946]">
            <div className="w-16 h-16 bg-[#E63946]/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <DollarSign className="w-8 h-8 text-[#E63946]" />
            </div>
            <div className="text-7xl font-bold text-[#E63946] mb-3" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
              $0
            </div>
            <div className="text-xl text-white font-bold mb-2" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
              STATE FUNDING
            </div>
            <p className="text-gray-400 text-sm">
              California programs losing critical rehabilitation funding
            </p>
          </div>

          {/* 1-in-3 Californians */}
          <div className="bg-gradient-to-br from-[#1a1a1a] to-[#0f0f0f] border-2 border-[#E63946]/30 rounded-2xl p-8 text-center transform hover:scale-105 transition-all duration-300 hover:border-[#E63946]">
            <div className="w-16 h-16 bg-[#E63946]/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <Users className="w-8 h-8 text-[#E63946]" />
            </div>
            <div className="text-7xl font-bold text-[#E63946] mb-3" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
              1:3
            </div>
            <div className="text-xl text-white font-bold mb-2" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
              CALIFORNIANS AFFECTED
            </div>
            <p className="text-gray-400 text-sm">
              1 in 3 Californians impacted by the criminal justice system
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CrisisStats;
